(() => {
  const replaceElement = (element, tagName) => {
    const replacement = document.createElement(tagName);
    Array.from(element.attributes).forEach((attribute) => replacement.setAttribute(attribute.name, attribute.value));
    while (element.firstChild) replacement.appendChild(element.firstChild);
    element.replaceWith(replacement);
    return replacement;
  };

  const normalizeKlaviyoHeadings = () => {
    document.querySelectorAll('[class*="klaviyo-form-"] h1').forEach((heading) => replaceElement(heading, 'h2'));
  };

  const normalizeNavigationIds = () => {
    document.querySelectorAll('[data-nav-desktop]').forEach((navigation, navigationIndex) => {
      navigation.querySelectorAll('[id^="nav-tier-"]').forEach((panel, panelIndex) => {
        const previousId = panel.id;
        const baseId = previousId.match(/^(nav-tier-\d+-\d+)/)?.[1]
          || previousId.replace(/--nav-\d+--panel-\d+$/, '');
        const nextId = `${baseId}--nav-${navigationIndex + 1}--panel-${panelIndex + 1}`;
        if (previousId === nextId) return;
        navigation.querySelectorAll(`[aria-controls="${CSS.escape(previousId)}"]`).forEach((control) => control.setAttribute('aria-controls', nextId));
        panel.id = nextId;
      });
    });
  };

  const updateLocalIdReferences = (element, previousId, nextId) => {
    const scope = element.closest('form, [id^="guide-protection-widget"], section') || element.parentElement || document;
    updateIdReferencesInScope(scope, previousId, nextId);
  };

  const updateIdReferencesInScope = (scope, previousId, nextId) => {
    scope.querySelectorAll('[for], [aria-controls], [aria-labelledby], [aria-describedby], [aria-owns]').forEach((reference) => {
      ['for', 'aria-controls', 'aria-labelledby', 'aria-describedby', 'aria-owns'].forEach((attribute) => {
        const value = reference.getAttribute(attribute);
        if (!value) return;
        const tokens = value.split(/\s+/);
        if (!tokens.includes(previousId)) return;
        reference.setAttribute(attribute, tokens.map((token) => token === previousId ? nextId : token).join(' '));
      });
    });
  };

  const dedupeExactId = (id, prefix = id) => {
    const matches = Array.from(document.querySelectorAll(`[id="${CSS.escape(id)}"]`));
    matches.slice(1).forEach((element, index) => {
      const nextId = `${prefix}-${index + 2}`;
      updateLocalIdReferences(element, id, nextId);
      element.id = nextId;
    });
  };

  const normalizeTargetedIds = () => {
    dedupeExactId('note', 'cart-note');
    dedupeExactId('guideprotection__popupscreen', 'guideprotection__popupscreen-instance');
    dedupeExactId('guideprotection__popupclose', 'guideprotection__popupclose-instance');

    const videoIds = Array.from(document.querySelectorAll('[id^="video-"]'))
      .reduce((ids, element) => {
        if (!ids.has(element.id)) ids.set(element.id, []);
        ids.get(element.id).push(element);
        return ids;
      }, new Map());

    videoIds.forEach((elements, id) => {
      elements.slice(1).forEach((element, index) => {
        const nextId = `${id}-instance-${index + 2}`;
        updateLocalIdReferences(element, id, nextId);
        element.id = nextId;
      });
    });
  };

  const normalizeYotpoIds = () => {
    const roots = Array.from(document.querySelectorAll('[id="yotpo-app"], [id^="yotpo-app-instance-"]'));
    roots.forEach((root, rootIndex) => {
      if (rootIndex > 0 && root.id === 'yotpo-app') root.id = `yotpo-app-instance-${rootIndex + 1}`;
      if (rootIndex === 0) return;
      root.querySelectorAll('[id]').forEach((element) => {
        const previousId = element.id;
        if (document.querySelectorAll(`[id="${CSS.escape(previousId)}"]`).length < 2) return;
        const nextId = `${previousId}-yotpo-${rootIndex + 1}`;
        updateIdReferencesInScope(root, previousId, nextId);
        element.id = nextId;
      });
    });

    const voteLabelGroups = Array.from(document.querySelectorAll('[id$="-votes_label"]'))
      .reduce((groups, element) => {
        if (!groups.has(element.id)) groups.set(element.id, []);
        groups.get(element.id).push(element);
        return groups;
      }, new Map());

    voteLabelGroups.forEach((elements, id) => {
      elements.slice(1).forEach((element, index) => {
        const nextId = `${id}-instance-${index + 2}`;
        const scope = element.closest('.yotpo-review-votes-wrapper, [id^="yotpo-app"]') || element.parentElement;
        updateIdReferencesInScope(scope, id, nextId);
        element.id = nextId;
      });
    });
  };

  const normalizeGuideProtection = () => {
    const widgets = Array.from(document.querySelectorAll('[id="guide-protection-widget"]'));
    widgets.slice(1).forEach((widget, index) => {
      widget.id = `guide-protection-widget-content-${index + 1}`;
    });

    document.querySelectorAll('[id^="guide-protection-widget"]').forEach((widget) => {
      const walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);
      textNodes.forEach((node) => {
        if (node.nodeValue && node.nodeValue.includes('|SHOP_NAME|')) {
          node.nodeValue = node.nodeValue.replaceAll('|SHOP_NAME|', 'Phoenician Grinders');
        }
      });

      widget.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
        if (!checkbox.getAttribute('aria-label') && !checkbox.getAttribute('aria-labelledby')) {
          checkbox.setAttribute('aria-label', 'Protect my package against loss, damage, or theft');
        }
      });

      widget.querySelectorAll('img:not([alt])').forEach((image) => {
        image.alt = /logo|guide/i.test(image.src) ? 'Guide Package Protection' : '';
      });
    });

    document.querySelectorAll('img[src*="guide-protection"]').forEach((image) => {
      image.alt = /logo/i.test(image.src) ? 'Guide Package Protection' : '';
    });
  };

  const normalizeProductDialog = () => {
    document.querySelectorAll('.fancybox-container').forEach((dialog) => {
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      dialog.setAttribute('aria-label', 'Expanded product image');
      if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');
      dialog.querySelectorAll('.fancybox-image').forEach((image) => {
        if (!image.alt) {
          const productTitle = document.querySelector('h1')?.textContent?.trim() || 'product';
          image.alt = `Expanded view of ${productTitle}`;
        }
      });
    });
  };

  let activeProductImageIndex = 0;
  let productImageTriggers = [];
  let productLightboxTrigger = null;
  let productLightboxDelegationInitialized = false;

  const ensureProductLightbox = () => {
    let dialog = document.getElementById('phoenician-product-lightbox');
    if (dialog) return dialog;

    dialog = document.createElement('dialog');
    dialog.id = 'phoenician-product-lightbox';
    dialog.className = 'phoenician-product-lightbox';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-label', 'Expanded product image');

    const closeDialog = () => {
      if (typeof dialog.close === 'function') dialog.close();
      else {
        dialog.removeAttribute('open');
        productLightboxTrigger?.focus();
      }
    };

    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'phoenician-product-lightbox__close';
    closeButton.setAttribute('aria-label', 'Close expanded product image');
    closeButton.textContent = '×';
    closeButton.addEventListener('click', closeDialog);

    const previousButton = document.createElement('button');
    previousButton.type = 'button';
    previousButton.className = 'phoenician-product-lightbox__previous';
    previousButton.setAttribute('aria-label', 'Show previous product image');
    previousButton.textContent = '‹';

    const image = document.createElement('img');
    image.className = 'phoenician-product-lightbox__image';

    const nextButton = document.createElement('button');
    nextButton.type = 'button';
    nextButton.className = 'phoenician-product-lightbox__next';
    nextButton.setAttribute('aria-label', 'Show next product image');
    nextButton.textContent = '›';

    const status = document.createElement('p');
    status.className = 'phoenician-product-lightbox__status';
    status.setAttribute('aria-live', 'polite');

    const showImage = (index) => {
      if (!productImageTriggers.length) return;
      activeProductImageIndex = (index + productImageTriggers.length) % productImageTriggers.length;
      const trigger = productImageTriggers[activeProductImageIndex];
      const source = trigger.getAttribute('data-src') || trigger.querySelector('img')?.getAttribute('data-zoom-src') || '';
      const alt = trigger.getAttribute('aria-label') || trigger.querySelector('img')?.alt || 'Phoenician grinder product image';
      image.src = new URL(source, window.location.href).href;
      image.alt = alt;
      status.textContent = `Image ${activeProductImageIndex + 1} of ${productImageTriggers.length}`;
      previousButton.hidden = productImageTriggers.length < 2;
      nextButton.hidden = productImageTriggers.length < 2;
    };

    previousButton.addEventListener('click', () => showImage(activeProductImageIndex - 1));
    nextButton.addEventListener('click', () => showImage(activeProductImageIndex + 1));
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showImage(activeProductImageIndex - 1);
      if (event.key === 'ArrowRight') showImage(activeProductImageIndex + 1);
    });
    dialog.addEventListener('close', () => productLightboxTrigger?.focus());

    dialog.append(closeButton, previousButton, image, nextButton, status);
    dialog.showPhoenicianImage = showImage;
    document.body.appendChild(dialog);
    return dialog;
  };

  const normalizeProductLightbox = () => {
    if (productLightboxDelegationInitialized) return;
    productLightboxDelegationInitialized = true;
    window.addEventListener('click', (event) => {
        const button = event.target?.closest?.('.product-gallery__zoom-button[data-src]');
        if (!button) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const group = button.getAttribute('data-fancybox');
        productImageTriggers = Array.from(document.querySelectorAll(`.product-gallery__zoom-button[data-fancybox="${CSS.escape(group || '')}"]`));
        if (!productImageTriggers.length) productImageTriggers = [button];
        activeProductImageIndex = Math.max(0, productImageTriggers.indexOf(button));
        productLightboxTrigger = button;
        const dialog = ensureProductLightbox();
        dialog.showPhoenicianImage(activeProductImageIndex);
        if (!dialog.open) {
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else {
            dialog.setAttribute('open', '');
            dialog.querySelector('.phoenician-product-lightbox__close')?.focus();
          }
        }
    }, true);
  };

  const normalizePageContent = () => {
    document.querySelectorAll('img[src*="PHOENICIAN_GRINDER_SIZE_CHART"]').forEach((image) => {
      image.alt = 'Phoenician grinder size compatibility chart for Small, Medium and Large models';
    });

    document.querySelectorAll('a[href*="/collections/best-grinder-4-piece"]').forEach((link) => {
      link.setAttribute('href', '/collections/pro-4-piece');
    });

    if (location.pathname.includes('the-ultimate-grinder-guide')) {
      document.querySelectorAll('#MainContent h5').forEach((heading) => replaceElement(heading, 'h3'));
    }

    document.querySelectorAll('img[src*="How_to_clean_grinder"]').forEach((image) => {
      image.alt = 'Phoenician grinder cleaning guide';
    });

    document.querySelectorAll('a > button').forEach((button) => {
      const link = button.parentElement;
      button.classList.forEach((className) => link.classList.add(className));
      if (button.style.cssText) link.style.cssText += `;${button.style.cssText}`;
      while (button.firstChild) link.insertBefore(button.firstChild, button);
      button.remove();
    });

    document.querySelectorAll('input.get-rates[type="button"]').forEach((button) => {
      if (!button.getAttribute('aria-label')) button.setAttribute('aria-label', button.value || 'Calculate shipping rates');
    });

    document.querySelectorAll('[class*="recently"], [id*="recently"]').forEach((container) => {
      container.querySelectorAll('img').forEach((image) => {
        if (image.getAttribute('alt')?.trim()) return;
        const card = image.closest('article, li, .thumbnail, .product-list--item, .gallery-cell, [class*="product-card"]') || image.parentElement;
        const title = card?.querySelector('[class*="title"], h2, h3, a[href*="/products/"]')?.textContent?.trim();
        image.alt = title ? `${title} product image` : 'Phoenician grinder product image';
      });
    });
  };

  const initializeSupportSearch = () => {
    const input = document.getElementById('support-faq-search');
    const results = document.getElementById('support-faq-results');
    if (!input || !results || input.dataset.initialized === 'true') return;
    input.dataset.initialized = 'true';

    const questions = () => Array.from(document.querySelectorAll('#faq-container .faqAccordion dt button'));
    const clearResults = () => {
      results.replaceChildren();
      results.textContent = '';
    };

    input.addEventListener('input', () => {
      const query = input.value.trim().toLowerCase();
      clearResults();
      if (query.length < 2) return;

      const matches = questions().filter((button) => button.textContent.trim().toLowerCase().includes(query));
      const status = document.createElement('p');
      status.textContent = matches.length === 1 ? '1 help topic found.' : `${matches.length} help topics found.`;
      results.appendChild(status);

      if (matches.length === 0) return;
      const list = document.createElement('ul');
      matches.forEach((question) => {
        const item = document.createElement('li');
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = question.textContent.trim();
        button.addEventListener('click', () => {
          if (question.getAttribute('aria-expanded') !== 'true') question.click();
          question.scrollIntoView({ behavior: 'smooth', block: 'center' });
          question.focus({ preventScroll: true });
          question.classList.add('faq-search-highlight');
          window.setTimeout(() => question.classList.remove('faq-search-highlight'), 2500);
          input.value = '';
          clearResults();
        });
        item.appendChild(button);
        list.appendChild(item);
      });
      results.appendChild(list);
    });
  };

  const appendSupportFaqSchema = () => {
    if (!location.pathname.endsWith('/pages/phoenician-grinders-support') || document.getElementById('support-faq-schema')) return;
    const questions = Array.from(document.querySelectorAll('#faq-container .faqAccordion dt button'));
    const entities = questions.map((question) => {
      const panelId = question.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : question.closest('dt')?.nextElementSibling;
      return {
        '@type': 'Question',
        name: question.textContent.trim(),
        acceptedAnswer: {
          '@type': 'Answer',
          text: panel?.textContent?.trim() || ''
        }
      };
    }).filter((entity) => entity.acceptedAnswer.text);
    if (entities.length === 0) return;
    const script = document.createElement('script');
    script.id = 'support-faq-schema';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: entities });
    document.head.appendChild(script);
  };

  const runRepairs = () => {
    normalizeKlaviyoHeadings();
    normalizeNavigationIds();
    normalizeTargetedIds();
    normalizeYotpoIds();
    normalizeGuideProtection();
    normalizeProductDialog();
    normalizeProductLightbox();
    normalizePageContent();
    initializeSupportSearch();
    appendSupportFaqSchema();
  };

  document.addEventListener('DOMContentLoaded', runRepairs);
  document.addEventListener('shopify:section:load', runRepairs);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && document.querySelector('.fancybox-container[style*="display: block"], .fancybox-container.fancybox-is-open')) {
      window.jQuery?.fancybox?.close();
    }
  });

  const observer = new MutationObserver(() => window.requestAnimationFrame(runRepairs));
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
